import Headings from '../PageDetails/Headings';
import About from '../PageDetails/About';
// import Footer from '../PageDetails/Footer'

function Home() {
  return (
    <header className="App-header">
      <Headings />
      <About />
      {/* <Footer /> */}
    </header>
  );
}

export default Home;
